import * as React from "react";

const Notice: React.FunctionComponent<{}> = () => {
  return (
    <div className="flex py-[10px] px-[6px] min-h-screen bg-zinc-100 ">
      <div className="min-h-full flex-col py-5 px-10 bg-white border-[1px] border-solid border-stone-300 rounded-[10px] ">
        <h2 className="my-4 font-medium text-[22px] leading-[26px]">
          Một số thông tin cần lưu ý
        </h2>
        <div className="ml-4 flex flex-col items-start space-y-[10px] text-zinc-800">
          <p className="text-[14px] leading-[18px]">
            1. Dịch vụ quảng bá bài đăng đang được mở thử nghiệm cho một số
            người dùng ngẫu nhiên có nội dung bài đăng liên quan đến kinh doanh
            Bất Động Sản. Chúng tôi sẽ thông báo sau về việc áp dụng cho các
            loại hình kinh doanh khác.
          </p>
          <p className="text-[14px] leading-[18px]">
            2. Thông tin số lượt xem trong ngày mang tính ước lượng, không phải
            con số cam kết sẽ đạt được. Số lượt xem có thể bị ảnh hưởng nếu tùy
            chỉnh quảng bá thu hẹp nhóm đối tượng.
          </p>
          <p className="text-[14px] leading-[18px]">
            3. Đây là dịch vụ <b>thanh toán trả trước</b>, số tiền sẽ{" "}
            <b>không được hoàn lại</b> trừ một số tình huống bất khả kháng. Đơn
            vị cung cấp dịch vụ có quyền quyết định hoàn tiền hoặc từ chối hoàn
            tiền.
          </p>
          <p className="text-[14px] leading-[18px]">
            4. Bài đăng quảng bá cần đảm bảo{" "}
            <a
              className="text-blue-600"
              href="https://help.zalo.me/huong-dan/chuyen-muc/chinh-sach-cong-dong-zalo/"
            >
              Chính sách cộng đồng Zalo
            </a>
            , bài đăng quảng bá sẽ được kiểm duyệt theo{" "}
            <a
              className="text-blue-600"
              href="https://ads.zalo.me/business/tong-quan-chinh-sach-quang-cao/"
            >
              Chính sách quảng cáo
            </a>
            , chúng tôi không đảm bảo bài đăng quảng bá sẽ được duyệt nếu không
            đáp ứng các chính sách trên. Bạn có quyền chỉnh sửa bài đăng cho phù
            hợp chính sách, nhưng số tiền chi trả cho dịch vụ sẽ không được hoàn
            lại.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Notice;
